import { Button, Grid, TextField } from "@material-ui/core";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useEffect, useState } from "react";
import axios from "../../../utils/axios";

// Utility function to format date as DD-MM-YYYY
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  
  const day = d.getDate(); // No leading zero for readability
  const month = d.toLocaleString("en-US", { month: "long" }); // Full month name
  const year = d.getFullYear();

  return `${day} ${month}, ${year}`;
};

const SettlementNote = ({ searchParams,settlementNo }) => {
  const { dividendType, claimStatus, searchBy, searchKeyword, settlementPart } =
    searchParams;

  const [data, setData] = useState([]);
  const [form, setForm] = useState({
    date: "",
    cashClaimText: "",
    numberStart: "",
    approvalMeeting: "",
    approvalDate: "",
  });
  const [generated, setGenerated] = useState(false);

  // Fetch API data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const page_no = 1;
        const page_limit = 500;

        const res = await axios.get(
          `/settlement/get-claims?page_no=${page_no}&page_limit=${page_limit}&dividend_type=${dividendType}&claim_status=${claimStatus}&filter_type=${searchBy}&filter_value=${searchKeyword}&settlement_no=${settlementNo}&settlement_part=${settlementPart}`
        );
      
        if (res.data?.success) {
          setData(res.data.payload.data);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    fetchData();
  }, [dividendType, claimStatus, searchBy, searchKeyword, settlementPart]);
  

  // Handle form input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const allFilled =
    form.date && form.cashClaimText && form.numberStart && form.approvalDate && form.approvalMeeting;

const hasData = Array.isArray(data) && data.length > 0;


const addJustifiedText = (doc, text, x, y, maxWidth, lineHeight = 4, fontSize = 9) => {
  doc.setFontSize(fontSize); // ✅ Set font size before text rendering

  const lines = doc.splitTextToSize(text, maxWidth);
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    if (i === lines.length - 1) {
      doc.text(line, x, y);
      y += lineHeight;
      continue;
    }

    const words = line.trim().split(/\s+/);
    if (words.length === 1) {
      doc.text(words[0], x, y);
      y += lineHeight;
      continue;
    }

    let wordsWidth = 0;
    for (const w of words) {
      wordsWidth += doc.getTextWidth(w);
    }

    const spaceCount = words.length - 1;
    const remaining = maxWidth - wordsWidth;
    const spaceWidth = remaining > 0 ? remaining / spaceCount : doc.getTextWidth(" ");

    let cursor = x;
    for (let j = 0; j < words.length; j++) {
      const w = words[j];
      doc.text(w, cursor, y);
      cursor += doc.getTextWidth(w) + spaceWidth;
    }

    y += lineHeight;
  }

  return y;
};


const addHeader = (doc) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const topY = 18;
  doc.setFont("times", "bold");
  doc.setFontSize(14);
  doc.text("Capital Market Stabilization Fund (CMSF)", pageWidth / 2, topY, { align: "center" });
  doc.setFont("times", "normal");
  doc.setFontSize(11);
  doc.text("DCCI Building (Level-3)", pageWidth / 2, topY + 5, { align: "center" });
  doc.text("65-66 Motijheel C/A, Dhaka-1000", pageWidth / 2, topY + 10, { align: "center" });

  doc.setLineWidth(0.2);
  doc.line(10, topY + 13, pageWidth - 10, topY + 13);

  return topY + 25;
};

function toTitleCaseKeepAcronyms(str) {
  if (!str) return ""; // ✅ Handle null, undefined, or empty

  const acronyms = ["PLC", "LTD", "AB"];

  return str
    .toLowerCase()
    .split(" ")
    .map((word) => {
      if (acronyms.includes(word.toUpperCase())) {
        return word.toUpperCase(); // keep as is
      }
      return word
        .split("-")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join("-");
    })
    .join(" ");
}



const handleDownloadPDF = () => {
  // Example: Custom size (e.g., 100mm x 200mm)
const doc = new jsPDF({
  orientation: "p",      // "p" = portrait, "l" = landscape
  unit: "mm",            // measurement unit
  format: [210, 280]     // [width, height] in the chosen unit
});

  const margin = 11;
  let y = addHeader(doc);
  doc.setFont("times", "bold");
  doc.setFontSize(9);
 

  doc.text(`Date: ${formatDate(form.date)}`, margin, y);
  y += 8;

  doc.setFont(undefined, "bold");
  const baseText = `${form.cashClaimText}`; // e.g. 40
   const suffix = "th";

doc.setFontSize(9);

doc.text(baseText, margin, y); // Write 40

// Measure width of the number so we know where to place 'th'
const numberWidth = doc.getTextWidth(baseText);

 doc.setFontSize(7); // Smaller for superscript
 doc.text(suffix, margin + numberWidth + 0.5, y - 1.5); // Slightly to the right & above

// Continue the rest of the sentence
doc.setFontSize(9);
doc.text(
  " Cash Claim Settlement of Investors through BEFTN from Community Bank Bangladesh Ltd.",
  margin + numberWidth + 3, // adjust spacing
  y
);

  doc.setFont(undefined, "normal");
  y += 12;
  const n = form.approvalMeeting === "1" ? "st" : form.approvalMeeting === "2" ? "nd" : form.approvalMeeting === "3" ? "rd" : "th";
  const paragraphs = [
    `${form.numberStart}. According to 10 (1) of Bangladesh Securities and Exchange Commission (Capital Market Stabilization Fund) Rules, 2021, If any shareholder or securities holder claims his cash dividend after transfer of such dividend to the bank account of the Fund, within 15 (Fifteen) days of receiving the such claim, the issuer shall, after proper verification of the claim, recommend with a piece of detailed information to the Chief of Operation of the Fund to pay off such dividend from the bank account of the Fund.`,
    `${parseInt(form.numberStart) + 1}. Provided  that  the  Chief  of  Operation  of  the  Fund  shall,  after  due scrutiny  with  the  data  base/bank  as  created  under  sub-rule  (5)  of rule 9 of these rules as well as the aforesaid recommendation and approval of the Board or the Operation Management Committee for settlement of investors' claims as the case may be, pay off such cash dividend  to  the  claimant  through electronic  fund  transfer  system within 15 (fifteen) working days of receiving of such recommendation with intimation to the concerned issuer.  `,
    `${parseInt(form.numberStart) + 2}. Now after scrutinizing the claims, the claims have been presented for approval at the ${form.approvalMeeting}${n} meeting of the Operations Management Committee (OMC), which was held on ${formatDate(form.approvalDate)}.`,
  ];

  paragraphs.forEach((p) => {
    doc.setFontSize(9);
    y = addJustifiedText(doc, p, margin, y, 185, 4);
    y += 2;
  });

  const tableData = data.map((row, i) => [
    i + 1,
    row.name,
    row.issuer_name,
    row.bo_id || row.folio_number || "",
    row.bankName,
    row.branchName,
    row.bAccountNo,
    row.routingNo,
    row.totalAmount,
  ]

);

  doc.autoTable({
    startY: y + 5,
    head: [["SL", "Name", "Issuer", "BO/Folio", "Bank", "Branch", "A/C No", "Routing", "Amount"]],
    body: tableData,
    styles: { fontSize: 7, textColor: "black", cellPadding: 1.5, overflow: "linebreak",valign: "middle"},
       columnStyles: {
         3: { cellWidth: 24, overflow: "visible", whiteSpace: "nowrap"}, // BO/Folio
         5: { cellWidth: 20, whiteSpace: "nowrap" }, // Branch
        // 6: { cellWidth: 24, overflow: "visible", whiteSpace: "nowrap" }, // A/C No
        // 7: { cellWidth: 20, overflow: "visible", whiteSpace: "nowrap" }, // Routing
         8: { cellWidth: 20, halign: "right" }, // Amount
      },
        didParseCell: function (data) {
    // Column 4 = "Bank", Column 5 = "Branch"
   if (data.section === 'body' && (data.column.index === 4 || data.column.index === 5)) {
  data.cell.styles.fontSize = 7;
  const val = data.cell.text && data.cell.text[0] ? data.cell.text[0] : ""; // ✅ prevent null error
  data.cell.text = [toTitleCaseKeepAcronyms(val)];
}

  },
    headStyles: { fillColor: [220, 220, 220], textColor: "black", fontStyle: "bold", fontSize: 8},
    
    margin: { left: margin, right: margin },
    theme: "grid",
    didDrawPage: function (data) {
      const pageWidth = doc.internal.pageSize.getWidth();
       const pageHeight = doc.internal.pageSize.getHeight();

      let yPos = 18;
      doc.setFont("times", "bold");
      doc.setFontSize(14);
      doc.text("Capital Market Stabilization Fund (CMSF)", pageWidth / 2, yPos, { align: "center" });
      yPos += 5;
      doc.setFont("times", "normal");
      doc.setFontSize(11);
      doc.text("DCCI Building (Level-3)", pageWidth / 2, yPos, { align: "center" });
      yPos += 5;
      doc.text("65-66 Motijheel C/A, Dhaka-1000", pageWidth / 2, yPos, { align: "center" });
      doc.setLineWidth(0.2);
      doc.line(10, yPos + 3, pageWidth - 10, yPos + 3);

      // const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.text(`Page ${data.pageNumber}`, pageWidth / 2, pageHeight - 8, { align: "center" });

      data.settings.margin.top = 40;
    },
  });

  let finalY = doc.lastAutoTable.finalY + 8;

  const moreParagraphs = [
    `${parseInt(form.numberStart) + 3}. According to Rule, 8 (7) of Bangladesh Securities and Exchange Commission (Capital Market Stabilization Fund) Rules 2021, all payments of investors’ claims shall be made from the bank account through electronic fund transfer. `,
    "Earlier CMSF settled the claim amount from the operational account of Mercantile Bank. As per the verbal direction of BSEC from now on, CMSF will resolve all the claim amounts from the Community Bank Bangladesh Ltd. as it is the principal bank account of the organization, and all the issuer companies have provided the investors’ money in this bank.",
    `${parseInt(form.numberStart) + 4}. This transfer will be done through BEFTN from CMSF’s SND Account no: 0010311521301 maintained in the Community Bank Bangladesh Ltd, Gulshan Corporate Branch to the above-mentioned Claimants’ accounts.`,
    "Seeking your kind approval for the BEFTN request from Community Bank Ltd., Gulshan Corporate Branch, Dhaka A/C No. 0010311521301.",
    "This is for your kind approval.",
  ];

moreParagraphs.forEach((p) => {
  const split = doc.splitTextToSize(p, 180);
  if (finalY + split.length * 4 > 280) {
    doc.addPage();
    finalY = addHeader(doc);
  }
  finalY = addJustifiedText(doc, p, margin, finalY, 185, 4);
  finalY += 2; // spacing between paragraphs
});


  doc.save(`${form.cashClaimText.replace(/\s+/g, "_")}_Settlement_Note.pdf`);
};

  return (
    <Grid>
      {!generated ? (
        // Input Form
        <div >
          <h3>Fill Settlement Note Info</h3>

          <TextField
            label="Note Date"
            type="date"
            name="date"
            value={form.date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            style={{ margin: "10px" }}
          />

          <TextField
            label="Settlement No"
            name="cashClaimText"
            value={form.cashClaimText}
            onChange={handleChange}
            placeholder="e.g., 40th Cash Claim Settlement"
            style={{ margin: "10px", width: "200px" }}
          />

          <TextField
            label="Starting Note No"
            type="number"
            name="numberStart"
            value={form.numberStart}
            onChange={handleChange}
            style={{ margin: "10px" }}
          />
             <TextField
            label="Approval OMC Meeting No"
            type="number"
            name="approvalMeeting"
            value={form.approvalMeeting}
            onChange={handleChange}
            
            style={{ margin: "10px" }}
          />
          <TextField
            label="ApprovaL Date"
            type="date"
            name="approvalDate"
            value={form.approvalDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            style={{ margin: "10px" }}
          />

          <div>
          <Button
            variant="contained"
            color="primary"
            disabled={!allFilled || !hasData} // ✅ disable if no data
            onClick={() => setGenerated(true)}
            style={{ marginTop: "20px" }}
          >
            Generate
          </Button>

          {!hasData && (
            <p style={{ color: "red", fontSize: "13px", marginTop: "8px" }}>
              ⚠️ No data found for this filter — cannot generate settlement note.
            </p>
          )}

          </div>
        </div>
      ) : (
        // Generated Note + Table
        <div >
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "5px" }}>
            <h4 style={{ margin: 0 }}>Capital Market Stabilization Fund (CMSF)</h4>
            <p style={{ margin: 0 }}>DCCI Building (Level-3)</p>
            <p style={{ margin: 0 }}>65-66 Motijheel C/A, Dhaka-1000</p>
          </div>

          {/* Date */}
          <p style={{ textAlign: "justify" }}>
            <strong>Date:</strong> {formatDate(form.date)}
          </p>

          {/* Subject */}
          <p style={{ textAlign: "justify" }}>
            <strong>
              {form.cashClaimText}<sup>th</sup> Cash Claim Settlement of Investors through BEFTN from Community Bank
              Bangladesh Ltd.
            </strong>
          </p>

          {/* Paragraphs */}
          <p style={{ textAlign: "justify" }}>
            {form.numberStart}. According to 10 (1) of Bangladesh Securities and
            Exchange Commission (Capital Market Stabilization Fund) Rules, 2021,
            If any shareholder or securities holder claims his cash dividend after
            transfer of such dividend to the bank account of the Fund, within 15
            (Fifteen) days of receiving the such claim, the issuer shall, after
            proper verification of the claim, recommend with a piece of detailed
            information to the Chief of Operation of the Fund to pay off such
            dividend from the bank account of the Fund.
          </p>

             <p style={{ textAlign: "justify" }}>
            {parseInt(form.numberStart) + 1}. Provided  that  the  Chief  of  Operation  of  the  Fund  shall,  after  due scrutiny  with  the  data  base/bank  as  created  under  sub-rule  (5)  of rule 9 of these rules as well as the aforesaid recommendation and approval of the Board or the Operation Management Committee for settlement of investors' claims as the case may be, pay off such cash dividend  to  the  claimant  through electronic  fund  transfer  system within 15 (fifteen) working days of receiving of such recommendation with intimation to the concerned issuer.  
          </p>

          <p style={{ textAlign: "justify" }}>
            {parseInt(form.numberStart) + 2}. Now after scrutinizing the claims,
            the claims have been presented for approval at the {form.approvalMeeting}<sup>th</sup> Operations
            Management Committee (OMC), which was held on{" "}
            {formatDate(form.approvalDate)}.
          </p>

          {/* Table */}
          <TableContainer
            component={Paper}
            style={{ marginTop: "20px", maxHeight: "400px", overflowY: "auto" }}
          >
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  {[
                    "SL",
                    "Name",
                    "Issuer",
                    "BO/Folio",
                    "Bank",
                    "Branch",
                    "A/C No",
                    "Routing",
                    "Amount",
                  ].map((col, idx) => (
                    <TableCell
                      key={idx}
                      style={{
                        padding: "4px 8px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        border: "1px solid #ddd",
                        background: "#f5f5f5",
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        
                      }}
                    >
                      {col}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {data.length > 0 ? (
                  data.map((row, index) => (
                    <TableRow
                      key={index}
                      hover={true}
                      style={{ transition: "background 0.2s" }}
                    >
                      <TableCell
                        style={{
                          padding: "4px 8px",
                          fontSize: "11px",
                          border: "1px solid #ddd",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell style={{ fontSize: "11px", border: "1px solid #ddd" }}>
                        {row.name}
                      </TableCell>
                      <TableCell style={{ fontSize: "11px", border: "1px solid #ddd" }}>
                        {row.issuer_name}
                      </TableCell>
                      <TableCell style={{ fontSize: "11px", border: "1px solid #ddd" }}>
                        {row.bo_id || row.folio_number || ""}
                      </TableCell>
                      <TableCell style={{ fontSize: "11px", border: "1px solid #ddd" }}>
                       {toTitleCaseKeepAcronyms(row.bankName)}
                      </TableCell>
                      <TableCell style={{ fontSize: "11px", border: "1px solid #ddd" }}>
                        {toTitleCaseKeepAcronyms(row.branchName)}
                      </TableCell>
                      <TableCell style={{ fontSize: "11px", border: "1px solid #ddd" }}>
                        {row.bAccountNo}
                      </TableCell>
                      <TableCell style={{ fontSize: "11px", border: "1px solid #ddd" }}>
                        {row.routingNo}
                      </TableCell>
                      <TableCell style={{ fontSize: "11px", border: "1px solid #ddd" }}>
                        {row.totalAmount}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={9}
                      align="center"
                      style={{
                        padding: "6px",
                        fontSize: "12px",
                        border: "1px solid #ddd",
                      }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

             <p style={{ textAlign: "justify", marginTop: "20px" }}>
            {parseInt(form.numberStart) + 3}. According to Rule, 8 (7) of Bangladesh Securities and Exchange Commission (Capital Market Stabilization Fund) Rules 2021, all payments of investors’ claims shall be made from the bank account through electronic fund transfer.
          </p>    
          <p style={{ textAlign: "justify" }}>
            Earlier CMSF settled the claim amount from the operational account of Mercantile Bank. As per the verbal direction of BSEC from now on, CMSF will resolve all the claim amounts from the Community Bank Bangladesh Ltd. as it is the principal bank account of the organization, and all the issuer companies have provided the investors’ money in this bank.
          </p>  
          <p style={{ textAlign: "justify" }}>
            {parseInt(form.numberStart) + 4}.This transfer will be done through BEFTN from CMSF’s SND Account no: 0010311521301 maintained in the Community Bank Bangladesh Ltd, Gulshan Corporate Branch to the above-mentioned Claimants’ accounts.
          </p>  
          <p style={{ textAlign: "justify" }}>
           Seeking your kind approval for the BEFTN request from Community Bank Ltd., Gulshan Corporate Branch, Dhaka A/C No. 0010311521301.
          </p>
          <p style={{ textAlign: "justify" }}>
            This is for your kind approval.
          </p>
          
          {/* PDF Download Button */}
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <Button variant="outlined" color="primary" onClick={handleDownloadPDF}>
              Download PDF
            </Button>
          </div>
        </div>
      )}
    </Grid>
  );
};

export default SettlementNote;
